<template>
  <div class="thumb-slider">
    <!-- 标题 -->
    <span class="thumb-slider__title" @click="goDetail(currentItem)">{{ currentItem.title }}</span>

    <!-- 缩略图列表 -->
    <div class="thumb-slider__list">
      <div
        v-for="(item, idx) in items"
        :key="idx"
        class="thumb-slider__item"
        :class="{ 'thumb-slider__item--active': activeIndex === idx }"
        @click="setActive(idx)"
      >
        <img
          class="thumb-slider__image"
          referrerpolicy="no-referrer"
          :src="item.coverImage"
          alt="缩略图"
        />
      </div>
    </div>

    <!-- 来源 + 时间 -->
    <span class="thumb-slider__meta">{{ currentItem.categoryName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ currentItem.publishTime }}</span>
  </div>
</template>

<script>
export default {
  name: 'ThumbSlider',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  computed: {
    currentItem() {
      return this.items[this.activeIndex] || {};
    }
  },
  methods: {
    setActive(idx) {
      this.activeIndex = idx;
    },
    goDetail(item) {
      if (!item || !item.newsCode) return;
      this.$router.push(`/detail?newsCode=${item.newsCode}`);
    }
  }
};
</script>

<style scoped>
.thumb-slider {
  width: var(--content-width);
}

.thumb-slider__title {
  display: block;
  width: var(--content-width);
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 30px;
  cursor: pointer;
}

.thumb-slider__list {
  display: flex;
  justify-content: space-between;
  width: var(--content-width);
  margin-top: 20px;
}

.thumb-slider__item {
  width: 234px;
  height: 134px;
  border-radius: var(--radius-sm);
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
}

.thumb-slider__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.thumb-slider__item--active {
  border: 3px solid var(--color-primary);
}

.thumb-slider__item--active .thumb-slider__image {
  opacity: 1;
}

.thumb-slider__meta {
  display: block;
  color: var(--color-text-light);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  white-space: nowrap;
  line-height: 18px;
  margin-top: 19px;
}
</style>
